module.exports = __webpack_public_path__ + "static/media/1-05.0001e5d3.png";